import type { BlurEvent, FocusEvent } from 'react-native';

import { useState, useCallback } from 'react';

export function useFocus({
    onFocus,
    onBlur,
}: {
    onFocus?: (e: FocusEvent) => void;
    onBlur?: (e: BlurEvent) => void;
} = {}) {
    const [isFocused, setIsFocused] = useState(false);
    const handleFocus = useCallback(
        (e: FocusEvent) => {
            setIsFocused(true);
            onFocus?.(e);
        },
        [onFocus],
    );
    const handleBlur = useCallback(
        (e: BlurEvent) => {
            setIsFocused(false);
            onBlur?.(e);
        },
        [onBlur],
    );
    return { isFocused, handleFocus, handleBlur };
}
